import React from 'react';
import ReactGA from 'react-ga';
import CalendarMonthView from '../../assets/react-calendar-month-view';
import PopUpPerso from './PopUpCalendar';
import imgUrl from '../../assets/gie-logo-bg-3.jpg';
import GIECard from '../../components/GIECard/GieCard';
import GieCard from '../../components/GIECard/GieCard';
import CalendarController from '../../controller/calendar.controller';
import GIECheckBox from '../../components/GIECheckBox/GieCheckBox';
import GIEButton from '../../components/GIEButton/GieButton';
import {ListUtil} from '../../util/list-util';
import {Responsive} from '../../util/responsive';
import {DateUtil} from '../../util/date-util';
import PopUpError from './PopUpError';
import userInformations from '../../userInformation/user_informations';
import GIEServicesContainer from "../../components/GIEServicesContainer/GIEServicesContainer";
import TitleListScreen from "../../components/TitleListeScreen/TitleListScreen";

export default class GIECalendar extends React.Component<any, any> {
  calendarController: CalendarController = new CalendarController();
  disableSelection: boolean = false;

  constructor(props) {
    super(props);
    this.state = {
      open: false,
      date: null,
      listAppointment: [],
      listFreeAppointment: [],
      isCancel: false,
      listOfDay: [1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
      appointmentString: '',
      itsTooLate: false,
      diffDays: 0,
      manualSearch: false,
      startDateCalendar: null,
      nbOfPlanif: 0,
      responseErrorText: '',
      mail: '',
      error: false,
      errorText: '',
      rawData: {afternoon: '', morning: ''}
    }
  }

  componentDidMount() {
    this.closeModal = this.closeModal.bind(this)
    this.manageStarDateCalendar(DateUtil.convertDateForCalendar(new Date()))

    this.getData(true);
    ReactGA.pageview(window.location.pathname + window.location.search);
    this.setState({emailSend: false})
  }

  getData = (isInitial: boolean) => {
    const noContract = userInformations.getNoContract()
    if (!noContract?.length) {
      window.location.href = "/admin/login"
    } else {
      const request = {
        noContract,
        setupDayDispo: this.state.listOfDay
      }
      this.calendarController.getFreePlanning(request).then((data: any) => {
        this.manageData(data, isInitial);
      }).catch(error => {
        console.log(error)
      })
    }
  }

  manageData = (data, isInitial: boolean) => {
    this.setState({rawData: data, manualSearch: !isInitial})
    const tooLate: boolean = this.setAppointment(data);
    if (!tooLate) {
      this.setFreeItems(data);
    }
    if (data.plannedTime?.length) {
      this.manageStarDateCalendar(data.plannedIntervention)
    }
    this.setState({
      nbOfPlanif: data.nbOfPlanif,
      // responseErrorText: data.responseErrorText,
      mail: data.mail,
      appointmentString: data.plannedInterventionString
    })
  }

  manageStarDateCalendar = (plannedIntervention) => {
    const dateStringSplitted = plannedIntervention.split('/');
    const startDateCalendar = dateStringSplitted[1] + '-' + dateStringSplitted[0] + '-20' + dateStringSplitted[2];
    this.setState({startDateCalendar})
    return startDateCalendar;
  }

  setFreeItems = data => {
    let groupedList = ListUtil.groupBy(data.planningAvailability, 'day');
    let listFreeAppointment = [];
    if (data.nbOfPlanif >= 2) {
      this.setState({
        listFreeAppointment,
        responseErrorText: 'Vous avez déplacé à deux reprises votre rendez-vous d’entretien annuel et ne pouvez donc plus accéder au service. <br>Pour reporter à nouveau votre rendez-vous, contactez nos services par email à l’adresse <a href="mailto:appareil.individuel@gie-sa.fr">appareil.individuel@gie-sa.fr</a> ou par téléphone au <a href="tel:+33388325352">03 88 32 53 52</a>.'
      })
      return;
    }
    Object.keys(groupedList).forEach((key) => {
      let date: Date = new Date();
      let dateStringSplitted = groupedList[key][0].day.split('/');
      date.setFullYear(Number("20" + dateStringSplitted[2]), Number(dateStringSplitted[1]) - 1, Number(dateStringSplitted[0]))
      if (groupedList[key].length === 2) {
        date.setHours(12, 0, 0, 0)
      } else if (groupedList[key][0].ok === 'AM-OK') {
        date.setHours(9, 0, 0, 0)
      } else if (groupedList[key][0].ok === 'PM-OK') {
        date.setHours(14, 0, 0, 0)
      }
      listFreeAppointment.push(date);
    });
    if (!listFreeAppointment?.length) {
      this.setState({responseErrorText: 'Aucun créneau disponible'})
    }
    this.setState({listFreeAppointment})
  }

  setAppointment = data => {
    let appointment: Date = DateUtil.convertDateNavisionToDate(data.plannedIntervention);
    const tooLate: boolean = this.itsTooLate(data);
    let timeStringSplitted = data.plannedTime.split(':');
    appointment.setHours(timeStringSplitted[0], 0, 0, 0);
    this.setState({listAppointment: [appointment]});
    return tooLate;
  }

  dateIsInList = (date, list) => {
    let isInList = null;
    let currentDay = new Date(date);
    list.forEach((appointment) => {
      if (appointment.getMonth() === currentDay.getMonth() &&
        appointment.getFullYear() === currentDay.getFullYear()
        && appointment.getDate() === currentDay.getDate()) {
        isInList = appointment;
      }
    })
    return isInList;
  }

  _renderDay = (date, isSmallCalendar) => {
    let isAppointment = this.dateIsInList(date, this.state.listAppointment);
    let isFree = this.dateIsInList(date, this.state.listFreeAppointment);

    if (isAppointment != null) {
      return this._renderAppointment(isAppointment, isSmallCalendar)
    } else if (isFree != null) {
      return this._renderFreeTime(isFree, isSmallCalendar)
    }
  };

  displayAppointmentDesktop = (appointment) => {
    return (
      <div className="d-flex align-items-end justify-content-center">
        <GIEButton classes={{root: 'orange-btn'}} disabled={this.disableSelection} styleClass="w-100 m-1">
          <div className="fs-7">
            <div>VOTRE RDV</div>
            <div>{this.state.rawData.plannedTimeIsMorning === true ? this.state.rawData.morning : this.state.rawData.afternoon}</div>
          </div>
        </GIEButton>
      </div>
    )
  }

  displayAppointmentMobile = (appointment) => {
    return (
      <div className="d-flex align-items-end justify-content-center">
        <GIEButton classes={{root: 'orange-btn'}} disabled={this.disableSelection} styleClass="w-100 m-1 p-0">
          <span className="fs-7">Votre RDV</span>
        </GIEButton>
      </div>
    )
  }

  _renderAppointment = (appointment, isSmallCalendar) => {
    if (!isSmallCalendar) {
      return (this.displayAppointmentDesktop(appointment));
    } else {
      return (this.displayAppointmentMobile(appointment));
    }
  }

  itsTooLate = data => {
    let appointment: Date = DateUtil.convertDateNavisionToDate(data.plannedIntervention)
    const diffTime = appointment.getTime() - new Date().getTime();
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    if (diffDays < 7) {
      this.setState({itsTooLate: true, diffDays})
      return true;
    }
    return false;
  }

  getDayMoment = (free) => {
    let moment = 'Matin';
    if (free.getHours() > 12) {
      moment = 'après-midi';
    } else if (free.getHours() === 12) {
      moment = 'Journée';
    }
    return moment;
  }

  displayFreeItemDesktop = (free) => {
    return (
      <div className="d-flex align-items-center justify-content-center">
        {this.getDayMoment(free) === 'Journée' ? (
          <div className="m-1 w-100">
            <GIEButton onClick={() => this.openModal(new Date(free.setHours(9, 0, 0, 0)), false)}
                       classes={{root: 'blue-btn'}} styleClass="d-block mb-2 w-100"
                       disabled={this.disableSelection}>
              <span className="fs-7">{this.state.rawData.morning}</span>
            </GIEButton>
            <GIEButton onClick={() => this.openModal(new Date(free.setHours(14, 0, 0, 0)), false)}
                       classes={{root: 'blue-btn'}} styleClass="d-block w-100"
                       disabled={this.disableSelection}>
              <span className="fs-7">{this.state.rawData.afternoon}</span>
            </GIEButton>
          </div>
        ) : (
          <GIEButton onClick={() => this.openModal(free, false)} classes={{root: 'blue-btn'}}
                     disabled={this.disableSelection} styleClass="w-100 m-1">
            <span className="fs-7">{this.displaySpanRenderFreeTime(free)}</span>
          </GIEButton>)}
      </div>
    )
  }

  displayFreeItemMobile = (free) => {
    return (
      <div className="d-flex align-items-center justify-content-center">
        {this.getDayMoment(free) === 'Journée' ? (
          <div className="w-100 m-1">
            <GIEButton onClick={() => this.openModal(new Date(free.setHours(9, 0, 0, 0)), false)}
                       classes={{root: 'blue-btn'}} styleClass="d-block p-0 mb-2 w-100"
                       disabled={this.disableSelection}>
              <span className="fs-7">{this.state.rawData.morning}</span>
            </GIEButton>
            <GIEButton onClick={() => this.openModal(new Date(free.setHours(14, 0, 0, 0)), false)}
                       classes={{root: 'blue-btn'}} styleClass="d-block p-0 w-100"
                       disabled={this.disableSelection}>
              <span className="fs-7">{this.state.rawData.afternoon}</span>
            </GIEButton>
          </div>) : (
          <GIEButton onClick={() => this.openModal(free, false)} classes={{root: 'blue-btn'}}
                     disabled={this.disableSelection} styleClass="p-0 w-100 m-1">
            <span className="fs-7">{this.displaySpanRenderFreeTime(free)}</span>
          </GIEButton>
        )}
      </div>
    )
  }

  _renderFreeTime = (free, isSmallCalendar) => {
    if (!isSmallCalendar) {
      return (this.displayFreeItemDesktop(free));
    } else {
      return (this.displayFreeItemMobile(free));
    }
  }

  zIndexRenderFreeItem = (): number => {
    return this.state.open || this.state.error ? -1 : 10;
  }

  displaySpanRenderFreeTime = (free) => {
    return this.getDayMoment(free) === 'Matin' ? this.state.rawData.morning : this.state.rawData.afternoon;
  }

  openModal = (date, isCancel) => {
    if (this.disableSelection) {
      return;
    }
    if (this.state.nbOfPlanif < 2) {
      this.setState({open: true, date, isCancel});
    } else {
      this.setState({
        error: true,
        errorText: 'Vous avez déplacé à deux reprises votre rendez-vous d’entretien annuel et ne pouvez donc plus accéder au service. Pour reporter à nouveau votre rendez-vous, contactez nos services par email à l’adresse <a href="mailto:appareil.individuel@gie-sa.fr">appareil.individuel@gie-sa.fr</a> ou par téléphone au <a href="tel:+33388325352">03 88 32 53 52</a>.'
      });
    }
  }

  savePlanning = (data, noContract, email, mobile, userNo, accept) => {
    this.disableSelection = true;
    const date: Date = new Date(data)

    let year = String(date.getFullYear());
    year = year.substring(year.length - 2, year.length);
    let month = date.getMonth() + 1 >= 10 ? Number(date.getMonth() + 1) : '0' + Number(date.getMonth() + 1)
    let day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
    let dateString = day + '/' + month + '/' + year;

    let time = date.getHours() > 12 ? 'PM-OK' : 'AM-OK';
    let affectedRessourceList = this.state.rawData.planningAvailability.filter(x => x.day === dateString && x.ok === time);
    let affectedResource;
    if (affectedRessourceList.length > 0) {
      affectedResource = affectedRessourceList[0].affectedRessource
    }
    const request = {
      noContract,
      affectedResource,
      meetingDate: dateString + ' ' + time,
      email,
      mobile,
      userNo,
      accept
    }
    this.calendarController.savePlanning(request).then(response => {
      // @ts-ignore
      if (response.error != null && response.error === true) {
        // @ts-ignore
        this.setState({error: true, errorText: response.text})
      }
      this.getData(false)
      this.disableSelection = false;
    }).catch(err => {
      console.log(err)
      this.disableSelection = false;
    })
  }

  clickOk = (data, email, mobile, userNo, accept) => {
    const noContract = userInformations.getNoContract()
    if (!noContract?.length) {
      window.location.href = "/admin/login"
    } else {
      this.savePlanning(data, noContract, email, mobile, userNo, accept)
    }
  }

  closeModal() {
    this.setState({open: false});
    this.getData(false);
  }

  checkADay = (event, index) => {
    let listOfDay = this.state.listOfDay;
    listOfDay[index] = listOfDay[index] === 1 ? 0 : 1;
    this.setState({listOfDay})
  }

  isMobile = () => {
    let isMobile = false;
    if (window.innerWidth <= Responsive.getMaxMobile(true)) {
      isMobile = true
    }
    return isMobile;
  }

  render() {
    return (
      <div className="content">
        <GIEServicesContainer imgUrl={imgUrl} title={<TitleListScreen miniTitle="Consultez les créneaux disponibles"
                                                                      href="rendez-vous"
                                                                      title="Votre rendez-vous"/>}>
          <div className="container-xl mb-5 d-flex flex-column gap-4">
            <GieCard width="100%" height="100%" className="p-4">
              <h3>Votre prochain rendez-vous est prévu le : {this.state.appointmentString}</h3>
              {!this.state.rawData?.planningAvailability?.[0]?.day || this.state.itsTooLate ? null : (
                <div className="fw-bold my-2">Le premier rendez-vous disponible est
                  le {this.state.rawData?.planningAvailability?.[0]?.day}.</div>
              )}
              <div>Vous disposez de jusqu’à 7 jours avant votre rendez-vous initial pour le reporter.</div>
              <div>
                Sachez que, même de plusieurs semaines, le report de votre rendez-vous d’entretien n’aura aucun impact
                sur la sécurité et le bon fonctionnement de votre installation.
              </div>
              {this.state.itsTooLate &&
                  <div className="fw-bold my-2">
                      Votre rendez-vous d’entretien est prévu dans {this.state.diffDays} jours. Vous ne pouvez plus le
                      replanifier.
                  </div>}
              {this.state.responseErrorText &&
                  <div className="fw-bold my-2" dangerouslySetInnerHTML={{__html: this.state.responseErrorText}}></div>}
            </GieCard>

            <GIECard width="100%" height="100%" className="p-4">
              <div>
                <h5>Veuillez nous communiquer vos disponibilités.</h5>
                <div className="row g-3 mt-2">
                  <div className="col-12 col-md-6 col-lg">
                    <GIECheckBox checked={this.state.listOfDay[0] === 1}
                                 emit={(event) => this.checkADay(event, 0)}
                                 label="Lundi matin"/>
                    <GIECheckBox checked={this.state.listOfDay[1] === 1}
                                 emit={(event) => this.checkADay(event, 1)}
                                 label="Lundi après-midi"/>
                  </div>
                  <div className="col-12 col-md-6 col-lg">
                    <GIECheckBox checked={this.state.listOfDay[2] === 1}
                                 emit={(event) => this.checkADay(event, 2)}
                                 label="Mardi matin"/>
                    <GIECheckBox checked={this.state.listOfDay[3] === 1}
                                 emit={(event) => this.checkADay(event, 3)}
                                 label="Mardi après-midi"/>
                  </div>
                  <div className="col-12 col-md-6 col-lg">
                    <GIECheckBox checked={this.state.listOfDay[4] === 1}
                                 emit={(event) => this.checkADay(event, 4)}
                                 label="Mercredi matin"/>
                    <GIECheckBox checked={this.state.listOfDay[5] === 1}
                                 emit={(event) => this.checkADay(event, 5)}
                                 label="Mercredi après-midi"/>
                  </div>
                  <div className="col-12 col-md-6 col-lg">
                    <GIECheckBox checked={this.state.listOfDay[6] === 1}
                                 emit={(event) => this.checkADay(event, 6)}
                                 label="Jeudi matin"/>
                    <GIECheckBox checked={this.state.listOfDay[7] === 1}
                                 emit={(event) => this.checkADay(event, 7)}
                                 label="Jeudi après-midi"/>
                  </div>
                  <div className="col-12 col-md-6 col-lg">
                    <GIECheckBox checked={this.state.listOfDay[8] === 1}
                                 emit={(event) => this.checkADay(event, 8)}
                                 label="Vendredi matin"/>
                    <GIECheckBox checked={this.state.listOfDay[9] === 1}
                                 emit={(event) => this.checkADay(event, 9)}
                                 label="Vendredi après-midi"/>
                  </div>
                </div>
                <div className="d-flex justify-content-between">
                  {!this.state.listFreeAppointment.length && this.state.manualSearch ?
                    (<div className="fw-bold text-uppercase">Aucun créneau disponible</div>) :
                    (<div></div>)
                  }
                  {this.state.itsTooLate ? null : <GIEButton disabled={this.state.itsTooLate}
                                                             styleClass="mt-3"
                                                             onClick={() => this.getData(false)}
                                                             classes={{root: 'orange-btn'}}>
                    Rechercher
                  </GIEButton>}
                </div>
              </div>
            </GIECard>
            <GIECard width="100%" height="100%">
              <CalendarMonthView renderDay={this._renderDay}
                                 style={{backgroundColor: 'transparent'}}
                                 dayTextStyle={{backgroundColor: 'transparent'}}
                                 activeTextStyle={{color: 'green'}}
                                 rdv={this.state.startDateCalendar}/>
            </GIECard>
          </div>
          <PopUpPerso mail={this.state.mail} closeModal={this.closeModal} cancel={this.state.isCancel}
                      confirmAppointment={this.clickOk} data={this.state.date} open={this.state.open}/>
          <PopUpError open={this.state.error} closeModal={() => this.setState({error: false})}
                      text={this.state.errorText}/>
        </GIEServicesContainer>
      </div>
    );
  }
}
